import { IconProps, iconA11yProps } from '../types';

export const Options = ({ classNames, label }: IconProps) => (
    <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 28" {...iconA11yProps(label)}>
        <g>
            <circle cx="4" cy="3" r="3" />
            <circle cx="4" cy="14" r="3" />
            <circle cx="4" cy="25" r="3" />
        </g>
    </svg>
);
